<mat-spinner *ngIf="loading"></mat-spinner>
<div *ngIf="!loading" class="clearfix full-width">
    <div style="text-align: left" class="pull-left">

        <button class="card-inline" (click)="openAdmisionLogViewDialog()" mat-icon-button *ngIf="!loadingAction">
            <mat-icon>search</mat-icon>
            <span>Actividades admisión</span>
        </button>

    </div>
    <div style="text-align: right;" class="pull-right">
        <mat-spinner *ngIf="loadingAction" [diameter]="20"></mat-spinner>

        <button *ngIf="!loadingAction" matTooltip="Cancelar" (click)="cancel()" mat-icon-button class="card-inline">
            <mat-icon>clear</mat-icon>
     </button>

        <button *ngIf="!loadingAction" matTooltip="Guardar" (click)="save()" mat-icon-button class="card-inline">
            <mat-icon>save</mat-icon>
        </button>

        <button *ngIf="!loadingAction" matTooltip="Revertir" (click)="finalizeRollBackOrderControlState()" mat-icon-button class="card-inline">
            <mat-icon>settings_backup_restore</mat-icon>
        </button>
        <button *ngIf="!loadingAction && !readOnly" matTooltip="Controlado parcialmente" (click)="save(partialControlStateId)" mat-icon-button class="card-inline">
            <mat-icon>done</mat-icon>
        </button>
        <button *ngIf="!loadingAction && !readOnly" matTooltip="Controlado" (click)="save(controlStateId)" mat-icon-button class="card-inline">
            <mat-icon>done_all</mat-icon>
        </button>
        <button *ngIf="!loadingAction && !readOnly" matTooltip="No facturar" (click)="showNoBillingReasonDialog()" mat-icon-button class="card-inline">
            <mat-icon>pan_tool</mat-icon>
     </button>
    </div>
</div>
<div class="full-width">
    <mat-tab-group *ngIf="!loading" (selectedIndexChange)="selectedIndexChange($event)" #tabGroup>
        <mat-tab label="Datos generales">
            <div class="card-base margin-botton-medium">
                <div class="card-content-wizard">
                    <div class="card-container mat-elevation-z1">
                        <div class="card-content">
                            <app-billing-orden-control-general #billingOrdenControlGeneral></app-billing-orden-control-general>
                        </div>
                    </div>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="Paciente">
            <div class="card-base  margin-botton-medium">
                <div class="card-content-wizard">
                    <div class="card-container mat-elevation-z1">
                        <app-billing-orden-control-patient #billingOrdenControlPatient></app-billing-orden-control-patient>
                    </div>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="Valorización">
            <div class="card-base  margin-botton-medium">
                <div class="card-content-wizard">
                    <div class="card-container mat-elevation-z1">
                        <app-billing-orden-control-valorization #billingOrdenControlValorization></app-billing-orden-control-valorization>
                    </div>
                </div>
            </div>
        </mat-tab>
        <app-billing-orden-control-invoice #billingOrdenControlInvoice></app-billing-orden-control-invoice>
        <mat-tab *ngIf="invoiceId || invoiceManualId" label="Cobranza">
            <div class="card-base  margin-botton-medium">
                <div class="card-content-wizard">
                    <div class="card-container mat-elevation-z1">
                        <iframe style="width:100%" height="500" *ngIf="getInvoiceSafeResourceUrl()" [src]="getInvoiceSafeResourceUrl()" type="application/pdf"></iframe>
                    </div>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="Escaneos">
            <div class="card-base  margin-botton-medium">
                <div class="card-content-scan">
                    <div class="card-container mat-elevation-z1">
                        <div class="card-content">
                            <app-billing-orden-control-scann #billingOrdenControlScann [hidden]="loading" [medicalorderId]="medicalOrderId"></app-billing-orden-control-scann>
                        </div>
                    </div>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="Orden">
            <div class="card-base margin-botton-medium">
                <div class="card-content-wizard">
                    <div class="card-container mat-elevation-z1">
                        <app-billing-orden-control-medical-order [hidden]="loading" #billingOrdenControlMedicalOrder></app-billing-orden-control-medical-order>
                    </div>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="Informe">
            <div class="card-base  margin-botton-medium">
                <div class="card-content-wizard" (resized)="onResized($event)">
                    <div class="card-container mat-elevation-z1">
                        <mat-form-field class="margin-left-large margin-top-medium">
                            <mat-select (selectionChange)="studyReportRegionViewChange()" [(ngModel)]="studyReportRegionView" placeholder="Región">
                                <mat-option *ngFor="let studyReportRegionView of studyReportRegionViews" [value]="studyReportRegionView">
                                    {{ studyReportRegionView.RegionName }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <iframe style="width:100%" height="500" *ngIf="getSafeResourceUrl()" [src]="getSafeResourceUrl()" type="application/pdf"></iframe>
                        <mat-spinner *ngIf="loadingReport" matSuffix></mat-spinner>
                    </div>
                </div>
            </div>
        </mat-tab>
        <mat-tab *ngIf="canViewControlOrdenAttachedFile" label="Archivos adjuntos">
            <div class="margin-botton-medium">
                <app-billing-orden-control-attached-file [medicalAppointmentId]="medicalAppointmentId"></app-billing-orden-control-attached-file>
            </div>
        </mat-tab>
        <mat-tab label="Operaciones">
            <div class="margin-botton-medium">
                <app-billing-orden-control-operation></app-billing-orden-control-operation>
            </div>
        </mat-tab>
    </mat-tab-group>
</div>
